import React, { useState } from 'react';
import TopBanner from '../../components/TopBanner';
import { Link } from 'react-router-dom';
import Accordion from 'react-bootstrap/Accordion';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { ChevronDown, ChevronUp } from 'react-bootstrap-icons'; 
// import ContentUnderWork from '../../components/ContentUnderWork';

export default function CloudSolutions() {

    const homeimg = '/images/service/cloud-solutions.png';
    const server_url = process.env.REACT_APP_SERVER;

    const schemaData = {
        "@context": "https://schema.org",
        "@type": "Service",
        "serviceType": "Cloud Solutions",
        "provider": {
            "@type": "Organization",
            "name": "Lurantech",
            "url": "https://lurantech.com",
            "logo": "https://lurantech.com/images/logo.png",
            "contactPoint": {
                "@type": "ContactPoint",
                "telephone": "+91-7226-999-101",
                "contactType": "Customer Service",
                "areaServed": "IN",
                "availableLanguage": "English"
            },
            "sameAs": [
                "https://www.facebook.com/Lurantech-107968334690860",
                "https://www.linkedin.com/company/lurantech",
                "https://x.com/lurantech"
            ],
            "address": {
                "@type": "PostalAddress",
                "streetAddress": "FF-401, 4th Floor, 7 Sky Complex, Laxmipura, Near VUDA Cross Road",
                "addressLocality": "Vadodara",
                "addressRegion": "Gujarat",
                "postalCode": "390021",
                "addressCountry": "IN"
            }
        },
        "description": "Leverage our cloud solutions to enhance scalability, improve security, and streamline operations, driving digital transformation and business growth.",
        "serviceAudience": {
            "@type": "Audience",
            "audienceType": "Business Clients"
        },
        "offers": [
            {
                "@type": "Offer",
                "priceCurrency": "INR",
                "price": "Contact for pricing",
                "eligibleRegion": {
                    "@type": "Place",
                    "name": "India"
                },
                "url": "https://lurantech.com/service/cloud-solutions"
            }
        ]
    }

    const [expanded, setExpanded] = useState(false);

    const handleAccordionToggle = () => {
        setExpanded(!expanded);
    };
    return (
        <>
            
            {/* <ContentUnderWork /> */}
            <HelmetProvider>
                <Helmet>
                    <meta property="og:title" content="LuranTech | Cloud Solutions | Scalable, Secure, and Efficient Cloud Services" />
                    <meta property="og:description" content="Leverage LuranTech's cloud solutions to enhance scalability, improve security, and streamline operations, driving digital transformation and business growth." />
                    <meta property="og:image" content={`${server_url}${homeimg}`} />
                    <meta property="og:url" content="https://lurantech.com/service/cloud-solutions" />
                    <meta property="og:type" content="website" />
                    <meta property="og:image:type" content="image/jpeg" />
                    <meta property="og:image:width" content="1200" />
                    <meta property="og:image:height" content="675" />

                    <meta name="twitter:title" content="LuranTech | Cloud Solutions | Scalable, Secure, and Efficient Cloud Services" />
                    <meta name="twitter:description" content="Leverage LuranTech's cloud solutions to enhance scalability, improve security, and streamline operations, driving digital transformation and business growth." />
                    <meta name="twitter:image" content={`${server_url}${homeimg}`} />
                    <meta name="twitter:card" content="summary_large_image" />
                    <meta property="twitter:image:type" content="image/jpeg" />
                    <meta property="twitter:image:width" content="1200" />
                    <meta property="twitter:image:height" content="675" />

                    <meta name="robots" content="index, follow" />
                    <meta name="description" content="Leverage LuranTech's cloud solutions to enhance scalability, improve security, and streamline operations, driving digital transformation and business growth." />
                    <meta name="keywords" content="Cloud Solutions, Cloud Computing, Cloud Migration, Scalable Infrastructure, Cloud Security, Business Growth, Digital Transformation, Cloud Automation" />
                    <meta name="author" content="LuranTech" />
                    <link rel="canonical" href="https://lurantech.com/service/cloud-solutions" />
                    <title>LuranTech | Cloud Solutions | Scalable, Secure, and Efficient Cloud Services</title>
                </Helmet>

                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{
                        __html: JSON.stringify(schemaData),
                    }}
                />
                
                <TopBanner title="Cloud Solutions" />
                <div className="it-sol-con">
                    <p>At LuranTech, we offer comprehensive <strong>Cloud Solutions</strong> that help businesses scale their operations, improve security, and achieve greater efficiency. Our cloud services are designed to accelerate your digital transformation journey, enabling you to unlock new business opportunities and reduce operational costs. Whether you are migrating to the cloud or optimizing existing cloud infrastructure, we provide custom solutions tailored to your needs.</p>
                    <br />
                    <div className='row g-4'>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <section className="service-section">
                                <div className='row g-2 p-2'>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" style={{textAlign: 'center'}}>
                                        <img src="/images/icons/cloud-services-1.png" alt="" style={{width: '100px'}} />
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 d-flex align-items-center justify-content-center">
                                        <h3>Cloud Infrastructure Management</h3>
                                    </div>
                                    <hr />
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header onClick={handleAccordionToggle}>{expanded ? <ChevronUp /> : <ChevronDown />}<span className='truncate-2'>We provide end-to-end cloud infrastructure management services to ensure high availability, scalability, and reliability. Our solutions help you optimize your cloud resources while minimizing operational costs and complexity.</span></Accordion.Header>
                                            <Accordion.Body>We provide end-to-end cloud infrastructure management services to ensure high availability, scalability, and reliability. Our solutions help you optimize your cloud resources while minimizing operational costs and complexity.</Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <p><strong>Key Benefits of Cloud Infrastructure Management:</strong></p>
                                        <ul>
                                            <li><strong>Scalability: </strong>Easily scale your infrastructure up or down based on business needs.</li>
                                            <li><strong>Reliability: </strong>Ensure business continuity with redundant, fault-tolerant systems.</li>
                                            <li><strong>Cost-Efficiency: </strong>Optimize cloud spending by leveraging cloud-native features and automated management.</li>
                                        </ul>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <section className="service-section">
                                <div className='row g-2 p-2'>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" style={{textAlign: 'center'}}>
                                        <img src="/images/icons/cloud-services-2.png" alt="" style={{width: '100px'}} />
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 d-flex align-items-center justify-content-center">
                                        <h3>Cloud Security</h3>
                                    </div>
                                    <hr />
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header onClick={handleAccordionToggle}>{expanded ? <ChevronUp /> : <ChevronDown />}<span className='truncate-2'>Ensure the security of your cloud data with our comprehensive cloud security solutions. From identity management to data encryption, we take a proactive approach to safeguard your cloud environment against emerging threats.</span></Accordion.Header>
                                            <Accordion.Body>Ensure the security of your cloud data with our comprehensive cloud security solutions. From identity management to data encryption, we take a proactive approach to safeguard your cloud environment against emerging threats.</Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <p><strong>Key Benefits of Cloud Security:</strong></p>
                                        <ul>
                                            <li><strong>Data Protection: </strong>Safeguard your sensitive business data with robust encryption and access controls.</li>
                                            <li><strong>Threat Detection: </strong>Identify and mitigate security risks using advanced monitoring tools.</li>
                                            <li><strong>Compliance: </strong>Ensure compliance with regulatory standards like GDPR and HIPAA.</li>
                                        </ul>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <br />
                    <br />
                    <div className='row g-4'>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <section className="service-section">
                                <div className='row g-2 p-2'>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" style={{textAlign: 'center'}}>
                                        <img src="/images/icons/cloud-services-3.png" alt="" style={{width: '100px'}} />
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 d-flex align-items-center justify-content-center">
                                        <h3>Cloud Migration</h3>
                                    </div>
                                    <hr />
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header onClick={handleAccordionToggle}>{expanded ? <ChevronUp /> : <ChevronDown />}<span className='truncate-2'>Seamlessly migrate your applications and data to the cloud with minimal disruption. Our cloud migration services ensure a smooth transition, minimizing risks and optimizing performance in your new cloud environment.</span></Accordion.Header>
                                            <Accordion.Body>Seamlessly migrate your applications and data to the cloud with minimal disruption. Our cloud migration services ensure a smooth transition, minimizing risks and optimizing performance in your new cloud environment.</Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <p><strong>Key Benefits of Cloud Migration:</strong></p>
                                        <ul>
                                            <li><strong>Risk Reduction: </strong>Ensure smooth and secure migration with professional support.</li>
                                            <li><strong>Performance Optimization: </strong>Enhance the performance and scalability of your cloud infrastructure.</li>
                                            <li><strong>Cost Efficiency: </strong>Reduce IT overhead by moving to a more flexible and cost-effective cloud model.</li>
                                        </ul>
                                    </div>
                                </div>
                            </section>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                            <section className="service-section">
                                <div className='row g-2 p-2'>
                                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 col-xl-4" style={{textAlign: 'center'}}>
                                        <img src="/images/icons/cloud-services-4.png" alt="" style={{width: '100px'}} />
                                    </div>
                                    <div className="col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 d-flex align-items-center justify-content-center">
                                        <h3>Cloud Automation</h3>
                                    </div>
                                    <hr />
                                    <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header onClick={handleAccordionToggle}>{expanded ? <ChevronUp /> : <ChevronDown />}<span className='truncate-2'>Leverage cloud automation to streamline repetitive tasks, enhance deployment cycles, and improve overall productivity. We help you implement DevOps principles for faster, more reliable cloud operations.</span></Accordion.Header>
                                            <Accordion.Body>Leverage cloud automation to streamline repetitive tasks, enhance deployment cycles, and improve overall productivity. We help you implement DevOps principles for faster, more reliable cloud operations.</Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <p><strong>Key Benefits of Cloud Automation:</strong></p>
                                        <ul>
                                            <li><strong>Operational Efficiency: </strong>Automate routine tasks to reduce manual effort and error.</li>
                                            <li><strong>Faster Deployment: </strong>Deploy applications and services faster with automated processes.</li>
                                            <li><strong>Continuous Improvement: </strong>Enable continuous integration and continuous delivery (CI/CD) pipelines for agile development.</li>
                                        </ul>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                    <br />
                    <h2>Why Choose LuranTech for Cloud Solutions?</h2>
                    <p>With years of experience and a deep understanding of cloud technologies, LuranTech provides innovative cloud solutions to help businesses scale efficiently and securely. We are committed to helping you achieve your digital transformation goals with tailored solutions that align with your unique business requirements.</p>
                    <p>We offer end-to-end cloud services including:</p>
                    <ul>
                        <li><strong>Cloud Strategy: </strong>Assess your goals and implement the best cloud solutions.</li>
                        <li><strong>Custom Cloud Solutions: </strong>Create tailored cloud architectures to support your business needs.</li>
                        <li><strong>Cloud Support & Optimization: </strong>Ensure your cloud environment is optimized for performance and cost-efficiency.</li>
                    </ul>
                    <hr />
                    <p>Ready to accelerate your digital transformation with cloud solutions? <Link style={{fontWeight:'600', color:'#232323', textDecoration:'underline'}} to='/contact-us'>Contact us today</Link> to learn more about how we can help your business grow.</p>
                    <span style={{fontSize:'10px'}}>All icons by <a target="_blank" rel="noreferrer" href="https://icons8.com">Icons8</a></span>
                </div>
            </HelmetProvider>
        </>
    );
}
